import React from "react";
import { Form, Input } from "antd";
import { BiMap } from "react-icons/bi";

const PaymentAddressSuburb = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="subUrb"
      label="Suburb"
      initialValue={""}
      rules={[
        {
          required: false,
          message: "Please input Suburb",
        },
        {
          whitespace: true,
          message: "Please input Suburb",
        },
      ]}
    >
      <Input
        prefix={<BiMap className="form-item-icon" />}
        placeholder="Suburb"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default PaymentAddressSuburb;
